import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import customInputStyle from "../../assets/jss/material-dashboard-pro-react/components/customInputStyle";

function CheckBox({ ...props }) {
    const {
        classes,
        inputProps,
        labelText,
        labelProps,
    } = props;

    return (
        <div>
            <InputLabel {...labelProps}>
                {labelText}
            </InputLabel>
            <Checkbox
                tabIndex={-1}
                classes={{
                    checked: classes.checked,
                    root: classes.checkRoot,
                }}
                {...inputProps}
            />
        </div>
    );
}

CheckBox.propTypes = {
    classes: PropTypes.object.isRequired,
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    inputRootCustomClasses: PropTypes.string,
    error: PropTypes.bool,
    success: PropTypes.bool,
    white: PropTypes.bool,
    helpText: PropTypes.node,
};

export default withStyles(customInputStyle)(CheckBox);